// extracted by mini-css-extract-plugin
export var standaloneTable = "_js-0";
export var standaloneTableWithBodyFill = "_js-1";
export var withExtraHeader = "_js-2";